import { TextAlign } from '@tiptap/extension-text-align';
import { Gif } from '../extension-gif/gif';
import { DaGallery } from '../extension-gallery/gallery';
import { DaDeviation } from '../extension-deviation/deviation';
import { areAnyNodesOfTypesNearby } from './utils';
import { DaVideo } from '../extension-video/daVideo';

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    daTextAlign: {
      /**
       * Set the text align attribute
       * @param alignment The alignment
       * @example editor.commands.setTextAlign('left')
       */
      setTextAlign: (alignment: string) => ReturnType;
      /**
       * Unset the text align attribute
       * @example editor.commands.unsetTextAlign()
       */
      unsetTextAlign: () => ReturnType;
    };
  }
}

const invalidExtensions: string[] = [
  Gif.name,
  DaGallery.name,
  DaDeviation.name,
  DaVideo.name,
];

export const DaTextAlign = TextAlign.extend({
  name: 'da-text-align',

  // Same as parent just added element.getAttribute('align') to support libreoffice pastes
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          textAlign: {
            default: this.options.defaultAlignment,
            parseHTML: element => {
              const alignment =
                element.style.textAlign ||
                element.getAttribute('align') ||
                this.options.defaultAlignment;

              return this.options.alignments.includes(alignment ?? '')
                ? alignment
                : this.options.defaultAlignment;
            },
            renderHTML: attributes => {
              if (attributes.textAlign === this.options.defaultAlignment) {
                return {};
              }

              return { style: `text-align: ${attributes.textAlign}` };
            },
          },
        },
      },
    ];
  },

  addCommands() {
    const parentCommands = this.parent?.();

    return {
      unsetTextAlign: parentCommands?.unsetTextAlign,
      setTextAlign: (alignment: string) => object => {
        if (
          areAnyNodesOfTypesNearby(this.editor.state, invalidExtensions) ||
          !parentCommands ||
          !parentCommands.setTextAlign
        ) {
          return false;
        }

        return parentCommands.setTextAlign(alignment)(object);
      },
    };
  },
});
